interface DeleteConfirmationModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Delete-confirmation modal for the Task Edit Modal.
 * Rendered via createPortal to document.body by the orchestrator.
 * Pure presentational leaf: all delete/close side effects are wired by the caller.
 */
export function DeleteConfirmationModal({ onCancel, onConfirm }: DeleteConfirmationModalProps) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 2147483648,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '25vh 16px 16px',
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: 'var(--color-surface)',
          borderRadius: '24px',
          maxWidth: '400px',
          width: '100%',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '24px' }}>
          <p style={{
            fontSize: '16px',
            color: '#6e7680',
            lineHeight: 1.6,
            margin: 0,
          }}>
            Are you sure you want to permanently delete this task? <strong>This action cannot be undone.</strong>
          </p>
        </div>
        <div style={{
          padding: '30px 24px 16px',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '15px',
        }}>
          <button
            onClick={onCancel}
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s',
              background: '#ffffff',
              border: '1px solid #e6e8ea',
              color: '#191d22',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f7f8f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#ffffff';
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s',
              // Monotone kanban modals: charcoal confirm (the copy carries the
              // destructive meaning; no red).
              background: '#3f4650',
              border: 'none',
              color: 'white',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#1d2228';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#3f4650';
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
